import { defineComponent,ref } from 'vue';
import axios, { AxiosResponse } from 'axios';
import DCApp from "./../Shared/App.vue";
import * as Vue from 'vue';
import * as bootstrap from "bootstrap";
import { createPinia } from 'pinia';


const mixin = defineComponent({
    data() {

        
        return {
            oldvalue: "",
            input: "",
            timeout: 0 as any,
            md5: "",
            sha1: "",
            sha256: "",
            sha512:""
        };
    },
    computed: {
        inputvalue: {
            get():string {
                return this.input;
            },
            set(val: string) {
                if (this.oldvalue == val)
                    return;
                this.oldvalue = val;
                if (this.timeout) clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.input = val;
                    this.process();
                }, 200);
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            $('[data-bs-toggle="popover"]').click(function () {
                if ($('.popover').next('div.popover:visible').length) {
                    $('.popover').popover('hide');
                } else {
                    $('.popover').popover('show');
                }

            });
            var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
            var popoverList = popoverTriggerList.map(function (popoverTriggerEl: any) {
                let popover=new bootstrap.Popover(popoverTriggerEl, {
                    container: 'body'

                });
                popoverTriggerEl.addEventListener('shown.bs.popover', function () {
                    setTimeout(() => { popover.hide(); }, 2000);
                })
                return popover;
            });
        });
    },
    methods: {
        Reinit() {
            this.input = "";
            this.oldvalue = "";
            this.md5 = "";
            this.sha1 = "";
            this.sha256 = "";
            this.sha512 = "";
        },
        CopyClipboard(text: string) {
            navigator.clipboard.writeText(text);
        },
        process() {
            this.ConvertToMD5(this.input);
            this.ConvertToSHA1(this.input);
            this.ConvertToSHA256(this.input);
            this.ConvertToSHA512(this.input);
        },
        ConvertToMD5(input:string) {
            let url = "/api/v1.0/ConvertMD5/ConvertToMD5?input=" + input;
            let self = this;
            if (input == "") {
                self.md5 = "";
                return;
            }
            axios.get<string>(url).then(function (response: AxiosResponse<string>) {
                if (response.data !== null) {
                    self.md5 = response.data;
                }
            });
        },
        ConvertToSHA1(input: string) {
            let url = "/api/v1.0/ConvertMD5/ConvertToSHA1?input=" + input;
            let self = this;
            if (input == "") {
                self.sha1 = "";
                return;
            }
            axios.get<string>(url).then(function (response: AxiosResponse<string>) {
                if (response.data !== null) {
                    self.sha1 = response.data;
                }
            });
        },
        ConvertToSHA256(input: string) {
            let url = "/api/v1.0/ConvertMD5/ConvertToSHA256?input=" + input;
            let self = this;
            if (input == "") {
                self.sha256 = "";
                return;
            }
            axios.get<string>(url).then(function (response: AxiosResponse<string>) {
                if (response.data !== null) {
                    self.sha256 = response.data;
                }
            });
        },
        ConvertToSHA512(input: string) {
            let url = "/api/v1.0/ConvertMD5/ConvertToSHA512?input=" + input;
            let self = this;
            if (input == "") {
                self.sha512 = "";
                return;
            }
            axios.get<string>(url).then(function (response: AxiosResponse<string>) {
                if (response.data !== null) {
                    self.sha512 = response.data;
                }
            });
        },
    }
});


export class ConvertMd5Component {

    public Init()
    {
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        app.mount('#rootpage');
    }
}
(<any>(window)).ConvertMd5Component = function () { return new ConvertMd5Component(); };